import { connect } from 'react-redux';
import { UsuariosListado } from './UsuariosListado';
// import { actions } from 

const ms2p = (state) => ({});

const md2p = {};

export default connect(ms2p, md2p)(UsuariosListado);